import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ZMediaText } from '@app/components/machine-infos/z-media-text.class';
import { MachineInfosService } from '@app/components/machine-infos/machine-infos.service';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { ExtractFileNamePipe } from '@app/pipes/extractFileName.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IonButton, IonPopover, IonList, IonItem, IonContent, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronDown } from 'ionicons/icons';
import { ImageFallbackSrcDirective } from '@app/directives/image-fallback-src.directive';

@Component({
    selector: 'app-zmedias',
    templateUrl: './zmedias.component.html',
    styleUrls: ['./zmedias.component.scss'],
    imports: [
        TranslateModule,
        AsyncPipe,
        ExtractFileNamePipe,
        NgbModule,
        IonButton,
        IonPopover,
        IonList,
        IonItem,
        IonContent,
        ImageFallbackSrcDirective,
        IonIcon
    ]
})
export class ZmediasComponent implements OnInit {
    @Input() mode: string;
    @Input() hasDescription: true;
    @Input() hasPreviews: boolean = false;

    content$: Observable<ZMediaText[]>;

    constructor(
        private readonly machineinfos: MachineInfosService,
        private readonly router: Router
    ) {
        addIcons({ chevronDown });
    }

    ngOnInit() {
        if (!this.mode) {
            this.mode = this.router.url.split('/').pop();
        }

        switch (this.mode) {
            case 'brochures': {
                this.content$ = this.machineinfos.brochures$;
                this.hasPreviews = true;
                break;
            }
            case 'operationmanual': {
                this.content$ = this.machineinfos.operationManuals$;
                break;
            }
            case 'retrofitmanual': {
                this.content$ = this.machineinfos.retrofitManuals$;
                break;
            }
            case 'sparepartlists': {
                this.content$ = this.machineinfos.sparepartLists$;
                break;
            }
            case 'lubricationplans': {
                this.content$ = this.machineinfos.lubricationPlans$;
                break;
            }
            case 'mechatronicplans': {
                this.content$ = this.machineinfos.mechatronicPlans$;
                break;
            }
            case 'assemblingInstructions': {
                this.content$ = this.machineinfos.assemblingInstructions$;
                break;
            }
            case 'repairingInstructions': {
                this.content$ = this.machineinfos.repairingInstructions$;
                break;
            }
        }

        this.content$.subscribe(contetn => {
            contetn.forEach(element => {
                element.description = this.addSpacer(element.description);
            });
        });
    }

    onClickLink(e: ZMediaText) {
        window.open(e.url, '_new');
    }

    getFileID(url: string): string {
        const splits = url.split('/');
        const lastUrlSegment = splits.at(-1);
        const fileNameSplits = lastUrlSegment.split('.');

        return fileNameSplits[0];
    }

    addSpacer(title: string) {
        return title.replaceAll(/,[^ ]/g, property => `${property.charAt(0)} ${property.charAt(1)}`);
    }

    goToLink(url: string) {
        window.open(url, '_blank');
    }

}
